import { routePaths } from './routePaths';


export const routeTo = {
  // Static paths
  root: () => `${routePaths.APP.ROOT}`,
  dashboard: () => `${routePaths.APP.ROOT}/${routePaths.APP.DASHBOARD}`,
  onboarding: () => `${routePaths.APP.ROOT}/${routePaths.APP.ONBOARDING}`,

  accountRoot: () => `${routePaths.APP.ROOT}/${routePaths.APP.ACCOUNT.ROOT}`,
  accountSettings: () => `${routePaths.APP.ROOT}/${routePaths.APP.ACCOUNT.ROOT}/${routePaths.APP.ACCOUNT.SETTINGS}`,
  accountBilling: () => `${routePaths.APP.ROOT}/${routePaths.APP.ACCOUNT.ROOT}/${routePaths.APP.ACCOUNT.BILLINGS}`,

  teamRoot: () => `${routePaths.APP.ROOT}/${routePaths.APP.TEAM.ROOT}`,
  teamSettings: () => `${routePaths.APP.ROOT}/${routePaths.APP.TEAM.ROOT}/${routePaths.APP.TEAM.SETTINGS}`,
  teamMembers: () => `${routePaths.APP.ROOT}/${routePaths.APP.TEAM.ROOT}/${routePaths.APP.TEAM.MEMBERS}`,
  teamBilling: () => `${routePaths.APP.ROOT}/${routePaths.APP.TEAM.ROOT}/${routePaths.APP.TEAM.BILLING}`,

  youtubeRoot: () => `${routePaths.APP.ROOT}/${routePaths.APP.YOUTUBE.ROOT}`,
  youtubeAnalytics: () => `${routePaths.APP.ROOT}/${routePaths.APP.YOUTUBE.ROOT}/${routePaths.APP.YOUTUBE.ANALYTICS}`,
  youtubeComments: () => `${routePaths.APP.ROOT}/${routePaths.APP.YOUTUBE.ROOT}/${routePaths.APP.YOUTUBE.COMMENTS}`,
  youtubeLiveChat: () => `${routePaths.APP.ROOT}/${routePaths.APP.YOUTUBE.ROOT}/${routePaths.APP.YOUTUBE.LIVECHAT}`,

  tiktokRoot: () => `${routePaths.APP.ROOT}/${routePaths.APP.TIKTOK.ROOT}`,
  tiktokAnalytics: () => `${routePaths.APP.ROOT}/${routePaths.APP.TIKTOK.ROOT}/${routePaths.APP.TIKTOK.ANALYTICS}`,
  tiktokComments: () => `${routePaths.APP.ROOT}/${routePaths.APP.TIKTOK.ROOT}/${routePaths.APP.TIKTOK.COMMENTS}`,


  // Auth
  signIn: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.SIGN_IN}`,
  signUp: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.SIGN_UP}`,
  signInEmail: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.SIGN_IN}?method=email`,
  signUpEmail: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.SIGN_UP}?method=email`,
  verifyOtp: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.VERIFY_OTP}`,
  forgotPassword: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.FORGOT_PASSWORD}`,
  resetPassword: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.RESET_PASSWORD}`,
  signOut: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.SIGN_OUT}`,
  oauthCallback: (provider: string) => `${routePaths.AUTH.ROOT}/callback/${provider}`,

  // Email
  emailRoot: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.EMAIL.ROOT}`,
  emailVerify: () => `${routePaths.AUTH.ROOT}/${routePaths.AUTH.EMAIL.ROOT}/${routePaths.AUTH.EMAIL.VERIFY}`,

  // Public
  help: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.HELP}`,
  privacy: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.PRIVACY}`,
  support: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.SUPPORT}`,
  contact: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.CONTACT}`,
  terms: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.TERMS}`,
  pricing: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.PRICING}`,
  faq: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.FAQ}`,
  aboutUs: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.ABOUT_US}`,
  blog: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.BLOG}`,
  extension: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.EXTENSION}`,

  features: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.FEATURES.ROOT}`,
  featuresCrossPlatform: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.FEATURES.ROOT}/${routePaths.PUBLIC.FEATURES.CROSS_PLATFORM}`,
  featuresAIAssistant: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.FEATURES.ROOT}/${routePaths.PUBLIC.FEATURES.AI_ASSISTANT}`,
  featuresCrisisDetection: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.FEATURES.ROOT}/${routePaths.PUBLIC.FEATURES.CRISIS_DETECTOR}`,
  featuresReporting: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.FEATURES.ROOT}/${routePaths.PUBLIC.FEATURES.REPORTING}`,
  featuresDashboard: () => `${routePaths.PUBLIC.ROOT}/${routePaths.PUBLIC.FEATURES.ROOT}/${routePaths.PUBLIC.FEATURES.DASHBOARD}`,
};


export const notRedirectIfAuthenticatedPaths = [
  routeTo.signOut(),
  "/auth/google/callback", // TODO: dynamic /auth/:provider/callback if available
  "/auth/facebook/callback"
];

export function getAllPaths() {
  const paths = new Set<string>()

  for (const key in routeTo) {
    const routeFn = (routeTo as any)[key]
    if (typeof routeFn === 'function') {
      try {
        const path = routeFn('provider') // give a dummy param for oauthCallback
        // Strip query params (optional, for cleaner sitemap URLs)
        paths.add(path.split('?')[0])
      } catch {
        // Ignore routes that need more specific params
      }
    }
  }

  return Array.from(paths)
}